// Generated-style fixture for the chess v2 migration slice.
// The engine init currently owns random IDs/choices, so this fixture pins the
// fields replay tests need to stay deterministic.

import type { ChessState } from "@cloudnest/augmented-chess-engine";
import { createInitialState } from "@cloudnest/augmented-chess-engine";

export interface ChessReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly color: "WHITE" | "BLACK";
}

export interface ChessReplayFixtureEvent {
  readonly id: string;
  readonly gameId: string;
  readonly eventType: string;
  readonly sequenceNumber: number;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
  readonly createdAt: string;
}

export interface ChessReplayFixture {
  readonly scenario: string;
  readonly players: readonly ChessReplayFixturePlayer[];
  readonly events: readonly ChessReplayFixtureEvent[];
  readonly notes: readonly string[];
}

const GAME_ID = "chess-replay-simple-2p-opening";
const CREATED_AT = "2026-06-10T00:00:00.000Z";

function createReplayInitialState(): ChessState {
  const state = createInitialState();
  return {
    ...state,
    id: GAME_ID,
    createdAt: CREATED_AT,
    updatedAt: CREATED_AT,
    augmentationSelection: {
      whiteChoices: ["extended_knight", "swift_pawn", "mobile_king"],
      blackChoices: ["diagonal_rook", "lateral_bishop", "ghost_bishop"],
      whiteSelected: false,
      blackSelected: false,
    },
  };
}

export const CHESS_REPLAY_FIXTURES: Readonly<
  Record<string, ChessReplayFixture>
> = {
  "simple-2p-opening": {
    scenario: "simple-2p-opening",
    players: [
      { id: "host-user", name: "Host", color: "WHITE" },
      { id: "guest-user", name: "Guest", color: "BLACK" },
    ],
    events: [
      {
        id: "event-1",
        gameId: GAME_ID,
        eventType: "init",
        sequenceNumber: 1,
        userId: "host-user",
        payload: {
          state: createReplayInitialState() as unknown as Record<
            string,
            unknown
          >,
        },
        createdAt: CREATED_AT,
      },
      {
        id: "event-2",
        gameId: GAME_ID,
        eventType: "select_augmentation",
        sequenceNumber: 2,
        userId: "host-user",
        payload: {
          player: "WHITE",
          augmentationId: "extended_knight",
          timestamp: 10,
        },
        createdAt: CREATED_AT,
      },
      {
        id: "event-3",
        gameId: GAME_ID,
        eventType: "select_augmentation",
        sequenceNumber: 3,
        userId: "guest-user",
        payload: {
          player: "BLACK",
          augmentationId: "diagonal_rook",
          timestamp: 20,
        },
        createdAt: CREATED_AT,
      },
      {
        id: "event-4",
        gameId: GAME_ID,
        eventType: "move",
        sequenceNumber: 4,
        userId: "host-user",
        payload: {
          pieceId: "white-pawn-12",
          from: { file: "e", rank: 2 },
          to: { file: "e", rank: 4 },
          timestamp: 30,
        },
        createdAt: CREATED_AT,
      },
      {
        id: "event-5",
        gameId: GAME_ID,
        eventType: "move",
        sequenceNumber: 5,
        userId: "guest-user",
        payload: {
          pieceId: "black-pawn-28",
          from: { file: "e", rank: 7 },
          to: { file: "e", rank: 5 },
          timestamp: 40,
        },
        createdAt: CREATED_AT,
      },
    ],
    notes: [
      "Pins initial augmentation choices for deterministic replay.",
      "Models the v2 typed event shape; the adapter also accepts legacy action events.",
    ],
  },
};
